import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const paymentGatewayList = createAsyncThunk('payment_gateway_config/gateways', async ({ navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + 'payment_gateway',
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const parameterByGateway = createAsyncThunk('payment_gateway_config/parameters', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `parameter_by_gateway/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const paymentGatewayConfigDetails = createAsyncThunk('payment_gateway_config/details', async ({ id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `config_by_premise/${id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

export const addPaymentGatewayConfig = createAsyncThunk('payment_gateway_config/add', async (data) => {
    try {
        const res = await axios({
            method: 'POST',
            url: getConfig.API_URL + 'gateway_config',
            data: {
                premise_id: data?.values?.premise,
                payment_gateway_id: data?.values?.paymentGateway,
                parameters: data?.values?.parameters?.map((param) => ({
                    parameter_id: param?.parameterId,
                    value: param?.value,
                })),
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const paymentGatewayConfig = createSlice({
    name: 'payment_gateway_config',
    initialState: {
        gateways: [],
        parameters: [],
        details: null,
        parametersLoading: false,
    },
    extraReducers: (builder) => {
        builder.addCase(paymentGatewayList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.gateways = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.gateways = []
            }
        });

        builder.addCase(parameterByGateway.pending, (state) => {
            state.parametersLoading = true;
        });
        builder.addCase(parameterByGateway.fulfilled, (state, action) => {
            state.parametersLoading = false;
            if (action?.payload?.status === 200) {
                state.parameters = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.parameters = []
            }
        });

        builder.addCase(paymentGatewayConfigDetails.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.details = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.details = null
            }
        });
    }
})

export default paymentGatewayConfig.reducer;